import React, { Fragment, lazy, memo, Suspense, useMemo } from 'react';

const TYPE_TO_COMPONENT_MAP = {
  BANNER_CAROUSEL_RIGHT: lazy(() => import('../sections/bannerCarouselRight')),
  GRID_CARD: lazy(() => import('../sections/list')),
  BANNER_CAROUSEL_CENTER: lazy(() =>
    import('../sections/bannerCarouselCenter')
  ),
  BANNER_CAROUSEL_LEFT: lazy(() => import('../sections/bannerCarouselLeft')),
  FORM_SUBSCRIBE: lazy(() => import('../sections/subscribeToNewsletter')),
  TEXT_TESTIMONIAL: lazy(() => import('../sections/testimonials')),
  VIDEO_TESTIMONIAL: lazy(() => import('../sections/videoTestimonials')),
  VIDEO: lazy(() => import('../sections/video')),
  INFO: lazy(() => import('../sections/info')),
  TEXT: lazy(() => import('../sections/text')),
  IMAGE_GALLERY: lazy(() => import('../sections/photoGallery')),
  FAQ_LISTING: lazy(() => import('../sections/faqListing')),
  COURSE_CAROUSEL: lazy(() => import('../sections/courseCarousel')),
  TEAM_CARD: lazy(() => import('../sections/teams')),
  TEXT_GRID: lazy(() => import('../sections/textGrid')),
  CONTACT: lazy(() => import('../sections/contact')),
  FORM_ENQUIRY: lazy(() => import('../sections/formEnquiry')),
  WEBINAR_LANDING_PAGE: lazy(() => import('../sections/webinarPromotionPage')),
  COURSE_LANDING_PAGE: lazy(() => import('../sections/coursePromotionPage')),
  FORM_LANDING_PAGE: lazy(() => import('../sections/formPage')),
  TILES_SECTION: lazy(() => import('../sections/tilesComponent')),
  EMAIL_DRIP_MARKET: lazy(() => import('../sections/EmailDripMarket')),
  ABOUT_INSTITUTE: lazy(() => import('../sections/aboutInstitute')),
  TIMER_AND_CALL: lazy(() => import('../sections/timerAndCall'))
};

const Carousel = lazy(() => import('../components/carousel'));

const getCompToRender = (type) => TYPE_TO_COMPONENT_MAP[type] || (() => null);

const MemoisedSection = memo(({ sectionData, extraProps, sectionIndex }) => {
  const SectionComp = getCompToRender(sectionData.type);

  return (
    <SectionComp
      sectionData={sectionData}
      extraProps={extraProps}
      sectionIndex={sectionIndex}
    />
  );
});

export default function SectionRenderer({
  sectionData,
  sectionIndex,
  extraProps
}) {
  return (
    <Suspense fallback={null /*GIF maybe*/}>
      <MemoisedSection
        sectionData={sectionData}
        extraProps={extraProps}
        sectionIndex={sectionIndex}
      />
    </Suspense>
  );
}
